'use strict'

flyoutMagicTriangle = require './flyout_magic_triangle'
activeClass = 'flyActive'

module.exports =
  init: ->
    $goodsTab = $('#subnav-goods-tab,#subnav-shop-tab')
    return unless ($menuElem = $goodsTab.find('.flyMenu')).length

    nestedMenulinks = '> li:not(.flyFlatLink)'
    flyoutOpts = {
      $menuElem,
      rowSelector: nestedMenulinks
      delay: 200
      onActivateRow: (elem) ->
        $(elem).addClass activeClass
      onDeactivateRow: (elem) ->
        $(elem).removeClass activeClass
    }

    flyoutInstance = flyoutMagicTriangle flyoutOpts

    return unless flyoutInstance

    $nestedLinks = $menuElem.find(nestedMenulinks)
    $nestedLinks.on 'tap', (e) ->
      e.stopPropagation()
      flyoutInstance.activateRow $(e.currentTarget)

    $firstLink = $nestedLinks.first()

    $goodsTab.bind 'tab:active', ->
      flyoutInstance.activateRow $firstLink



// WEBPACK FOOTER //
// ./modules/gig_body/header/sub_nav/frontend/init_flyout.coffee